export const actionTypes = {
    fetchCustomers : 'FETCH_CUSTOMERS',
    receiveCustomers : 'RECEIVE_CUSTOMERS',
    receiveCustomer : 'RECEIVE_CUSTOMER',
    setCustomer : 'SET_CUSTOMER',
    saveCustomer : 'SAVE_CUSTOMER',
    clearCustomer : 'CLEAR_CUSTOMER'
};